module.exports = __webpack_public_path__ + "static/media/antofagasta.743bb4b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/andimar/destinations/antofagasta.png
// module id = 1169
// module chunks = 0